import { eff } from "@/core/utils/effect-ts-abbr";
import { Prop, Vue } from "vue-property-decorator";
import { AppDropdownOptionDetails, AppDropdownOptionValue } from "./app-dropdown";

export type AppDropdownOptionProps = {
    // NOTE: In `single-optional` mode it can contain single element or can be empty.
    // NOTE: In `single` mode it will always contain single element.
    selectedValues: ReadonlyMap<AppDropdownOptionValue, AppDropdownOptionDetails>;
    details: AppDropdownOptionDetails;
    value: AppDropdownOptionValue;
    showCheckbox: boolean;
    toggle: () => void;
};

export class AppDropdownOptionComponent extends Vue {
    @Prop({ required: true, default: new Map() })
    selectedValues!: AppDropdownOptionProps["selectedValues"];

    @Prop()
    fontSize?: string;

    @Prop({ required: true, type: Object })
    details!: AppDropdownOptionProps["details"];

    @Prop({ default: false })
    showCheckbox!: AppDropdownOptionProps["showCheckbox"];

    @Prop()
    value!: AppDropdownOptionProps["value"];

    @Prop({ required: true, type: Function, default: eff.fn.identity })
    toggle!: AppDropdownOptionProps["toggle"];

    get isSelected(): boolean {
        return this.selectedValues.has(this.value);
    }
}
